<template>
  <div
    v-show="!isHidden"
    class="z-90 flex flex-col items-end animate-move hover:animate-none fixed bottom-0 right-8"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="cursor-pointer h-6 w-6 text-cw-alt hover:text-cw-700"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      @click="isHidden = true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
    <div
      class="bg-gradient-to-tr from-pink-600 to-purple-700 border border-white rounded-full cursor-pointer shadow-2xl mb-4"
      @click="toggleCwRegistration(target)"
    >
      <div
        class="w-28 h-28 m-2 flex flex-col justify-center items-center bg-black rounded-full bg-opacity-80"
      >
        <h6
          v-if="text"
          class="font-nunito text-sm text-white uppercase tracking-widest text-center"
        >
          {{ text }}
        </h6>
        <h4
          class="font-montserrat font-black uppercase text-2xl break-words bg-gradient-to-tr from-pink-600 to-purple-700 bg-clip-text text-transparent text-center leading-6"
        >
          {{ title }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'

export default {
  mixins: [shared],

  props: {
    text: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: 'Free Trial',
    },

    target: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      isHidden: false,
    }
  },

  methods: {
    // Type of enquiry; 0 === information, 1 === demo, 2 === sign up, 3 === upgrade plan, 4 === other, 5 === Hail, 6 === org registration (different modal!)
    toggleCwRegistration(type) {
      if (type === 6) {
        EventBus.$emit('showModal', 'cw-organisation-registration')
      } else {
        EventBus.$emit('showModal', 'cw-registration')
        setTimeout(() => {
          EventBus.$emit('new_reason', type)
        }, 50)
      }
    },
  },
}
</script>
